export const INTERVIEW_INVITATION_MODEL = "interview-invitation";
import { INTERVIEW_SLOT_MODEL } from "@/models/interview-slot-model";

const interviewInvitationModel = {
  status: "",
  createdAt: "",
  updatedAt: "",
  token: "",
  user: {
    jsonApi: "hasOne",
    type: "users"
  },
  interviewSlot: {
    jsonApi: "hasOne",
    type: INTERVIEW_SLOT_MODEL
  },
  interviewFormat: {
    jsonApi: "hasOne",
    type: "interview-format"
  }
};

export default interviewInvitationModel;
